export enum TipoDeOperador {
    Colaborador = 'COLABORADOR',
    Cliente = 'CLIENTE'
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/tipo-de-operador.enum.ts